import React, { useState, useEffect } from "react";
import { api, fmtCurrency, ROLE_LABELS } from "@/lib/api";
import { PageHeader } from "@/components/common/Primitives";
import { Card } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export default function Team() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/analytics/team").then(({ data }) => setRows(data)).catch(() => {}); }, []);

  return (
    <div>
      <PageHeader title="Sales Team Performance" subtitle="Factual metrics for each team member — no rankings, just the numbers" />
      <Card className="border border-slate-200/80 rounded-xl shadow-sm overflow-hidden">
        <div className="overflow-x-auto">
          <Table>
            <TableHeader>
              <TableRow className="bg-slate-50/80">
                {["Salesperson", "Role", "Leads", "Qualified", "RFQs", "Orders", "Revenue", "Gross Profit", "Conv. %", "Pending FU", "Overdue FU"].map((h) => (
                  <TableHead key={h} className="text-xs uppercase tracking-wider font-semibold text-slate-500 whitespace-nowrap">{h}</TableHead>
                ))}
              </TableRow>
            </TableHeader>
            <TableBody>
              {rows.map((r, i) => (
                <TableRow key={i} data-testid={`team-row-${i}`}>
                  <TableCell className="font-medium text-slate-800 whitespace-nowrap">{r.name}</TableCell>
                  <TableCell className="text-xs text-slate-500 whitespace-nowrap">{ROLE_LABELS[r.role]}</TableCell>
                  <TableCell>{r.leads}</TableCell>
                  <TableCell>{r.qualified}</TableCell>
                  <TableCell>{r.rfqs}</TableCell>
                  <TableCell>{r.orders}</TableCell>
                  <TableCell className="font-medium text-slate-900">{fmtCurrency(r.revenue)}</TableCell>
                  <TableCell className="font-medium text-emerald-600">{fmtCurrency(r.gross_profit)}</TableCell>
                  <TableCell>{r.conversion}%</TableCell>
                  <TableCell>{r.pending_followups}</TableCell>
                  <TableCell className={r.overdue_followups > 0 ? "text-rose-600 font-semibold" : ""}>{r.overdue_followups}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </Card>
    </div>
  );
}
